var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutOfStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1666C7.45467 15.1666 6.93333 14.9466 5.89133 14.508C3.29733 13.4153 2 12.8693 2 11.95V5.52798M8 15.1666C8.54533 15.1666 9.06667 14.9466 10.1087 14.508C12.7027 13.4153 14 12.8693 14 11.95V5.52798M8 15.1666V8.51998M2 5.52798C2 5.93665 2.53467 6.19465 3.60333 6.70998L5.55 7.64998C6.75267 8.22998 7.35333 8.51998 8 8.51998M2 5.52798C2 5.11998 2.53467 4.86198 3.60333 4.34665L4.66667 3.83331M14 5.52798C14 5.93665 13.4653 6.19465 12.3967 6.70998L10.45 7.64998C9.24733 8.22998 8.64667 8.51998 8 8.51998M14 5.52798C14 5.11998 13.4653 4.86198 12.3967 4.34665L11.3333 3.83331M4 9.18398L5.33333 9.84865M6.66667 1.83331L8 3.16665M8 3.16665L9.33333 4.49998M8 3.16665L6.66667 4.49998M8 3.16665L9.33333 1.83331",
    stroke: "#AF1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStock);
export default __webpack_public_path__ + "static/media/out-of-stock.338f28020b1cfe6b7ee696d283748fc0.svg";
export { ForwardRef as ReactComponent };